export const ACTIVITY_VARIANTS = {
  ADDED: 'added',
  REMOVED: 'removed',
};
